<template>
    <div class="answer-last-name answer-patient-info">

        <v-container v-if="getGoToBirthDate">
            <v-layout row>
                    <v-text-field v-model="lastName"
                                  autofocus
                                  class="chatbot-patient-info"
                                  @keyup="confirmLastName"
                                  :placeholder="text('api.chatbot.placeholder.patientLastName')"
                                  id="patient-last-name-input">
                    </v-text-field>

                    <a @click.once="goToBirth" v-if="lastName.length" class="pf-send-arrow">
                        <img src="../../../../assets/send_active.png" alt="avatar">
                    </a>
                    <a  v-else class="pf-send-arrow">
                        <img src="../../../../assets/send_disabled.png" alt="avatar">
                    </a>

            </v-layout>

        </v-container>

    </div>
</template>

<!-- ################################################################## -->

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AnswerLastName',
        data(){
            return {
                lastName: ''
            }
        },
        computed: {
            ...mapGetters({
                getGoToBirthDate: 'ChatBotStore/getGoToBirthDate'
            })
        },

        updated: function () {
            this.$nextTick(function () {
                 let elemChatBotPageContainer = document.querySelector(".chat-bot-conversation");
                 if(elemChatBotPageContainer !== null) {
                     elemChatBotPageContainer.scrollTop = elemChatBotPageContainer.scrollHeight;

                     let element = document.getElementById('patient-last-name-input');
                     if (element) {
                         element.scrollIntoView()
                     }
                 }
            });
        },


        watch: {
            getGoToBirthDate(newVal, oldVal) {

                if (newVal === true) {
                    this.$nextTick(function () {
                        this.$emit('onAnswerListUpdated');
                    });
                }

            }
        },

        methods: {

            handleClickProduct (clickedProduct) {
                this.$store.dispatch("ChatBotStore/selectProduct", clickedProduct);
            },
            goToBirth() {
                this.$store.commit('ChatBotStore/setPatientLastName', this.lastName);

                this.$store.dispatch("ChatBotStore/selectLastName", {
                    fieldName: "NAME",
                    fieldValue: this.lastName
                });
            },
            confirmLastName(e) {
                if(this.lastName.length) {
                    if (e.keyCode === 13) {
                        this.goToBirth();
                    }
                }
            },

        }
    }
</script>



// WEBPACK FOOTER //
// src/pathfinder/components/chatbot/answer-list/AnswerLastName.vue